import { Field } from 'formik';
import React from 'react';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomRadio from '../../../../common/ui/CustomRadio';

const BelongsToExtraSetting = ({
  validateRefCollectionId,
  collectionOptions,
  values,
  getBelongsToFieldOption,
  getFieldOption,
}) => {
  const collectionOptionsArray = collectionOptions(true).map((optionElement) => ({
    label: optionElement.props.children,
    value: optionElement.props.value,
  }));

  const parentFieldOptionsArray =
    values.refCollection && getBelongsToFieldOption(values.refCollection.collectionName)
      ? getBelongsToFieldOption(values.refCollection.collectionName)
          .filter(function (optionElement) {
            return optionElement !== undefined && optionElement !== null && optionElement.props;
          })
          .map(function (optionElement) {
            return {
              label: optionElement.props.children,
              value: optionElement.props.value,
            };
          })
      : [];

  const fieldOptionsArray =
    values.refCollection && getFieldOption(values.refCollection.collectionName)
      ? getFieldOption(values.refCollection.collectionName).map((optionElement) => ({
          label: optionElement.props.children,
          value: optionElement.props.value,
        }))
      : [];

  return (
    <>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <CustomInputWithIcon icon="diagram-2" extraCss="bmd-form-group">
          <Field name="refCollection.collectionName" validate={validateRefCollectionId}>
            {({ field, form, meta }) => (
              <>
                <CustomSelect
                  name={field.name}
                  value={field.value}
                  options={collectionOptionsArray}
                  placeholder="Select Parent Collection *"
                  onChange={(name, value) => form.setFieldValue(name, value)}
                />
                {meta.touched && meta.error && <p className="errors">{meta.error}</p>}
              </>
            )}
          </Field>
        </CustomInputWithIcon>
      </div>

      {values.refCollection && (
        <>
          <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
            <CustomInputWithIcon icon="capslock" extraCss="bmd-form-group">
              <Field name="refCollection.parentCollectionField" validate={validateRefCollectionId}>
                {({ field, form, meta }) => (
                  <>
                    <CustomSelect
                      name={field.name}
                      value={field.value}
                      options={parentFieldOptionsArray}
                      placeholder="Select Parent Field Name *"
                      onChange={(name, value) => form.setFieldValue(name, value)}
                    />
                    {meta.touched && meta.error && <p className="errors">{meta.error}</p>}
                  </>
                )}
              </Field>
            </CustomInputWithIcon>
          </div>

          <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
            <CustomInputWithIcon icon="static_option" extraCss="bmd-form-group">
              <Field name="refCollection.collectionField" validate={validateRefCollectionId}>
                {({ field, form, meta }) => (
                  <>
                    <CustomSelect
                      name={field.name}
                      value={field.value}
                      options={fieldOptionsArray}
                      placeholder="Select Field for Display *"
                      onChange={(name, value) => form.setFieldValue(name, value)}
                    />
                    {meta.touched && meta.error && <p className="errors">{meta.error}</p>}
                  </>
                )}
              </Field>
            </CustomInputWithIcon>
          </div>

          <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pl-5">
            <div className="form-check">
              <CustomRadio label="Use As Text/Hidden Field" isRadio={false}>
                <Field
                  className="form-check-input"
                  type="checkbox"
                  name="refCollection.isShowAsText"
                />
              </CustomRadio>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default BelongsToExtraSetting;
